// extracted by mini-css-extract-plugin
export var quillEditor = "_lt-1";
export var variable = "_lt-0";